import { createSelector } from "@ngrx/store";
import { selectCaseState } from "./common-case.selector";
import { EpicrisisCaseData } from "../../components/case-card/components/tab-header-components/case-epicrisis/interfaces/epicrisis.interface";
import { formatDate } from "@angular/common";
import { CaseState } from "../../interfaces/interfaces";

interface IVitalSign {
    id: number,
    input1: string,
    input2: string,
    numberOfInput: string,
    unit: string,
    parameter: {
        label: string,
        value: number
    }
}

export const selectCaseInfoForEpicrisis = createSelector(
  selectCaseState,
  (state): EpicrisisCaseData => {
    return {
        protocolNo: getProtocolNo(state),
        caseDate: state.case?.caseDate ? formatDate(new Date(state.case.caseDate), 'dd.MM.yyyy', 'tr') : '',
        doctor: '',
        patientName: (state.case.patient.firstName ?? '')+' '+(state.case.patient.lastName ?? ''),
        patientInformations: state.case.patient.contacts ,
        age: state.case.patient.age ? state.case.patient.age.toString() : '',
        gender: getGender(state),
        diagnoses: getDiagnoses(state),
        vitalSigns: getVitalSigns(state),
        services: getServices(state)
    }
  }
);

/*      Yardımcı fonksiyonlar       */
function getProtocolNo(state: CaseState): string {
    const caseNo = state.case.caseNo ? state.case.caseNo.toString() : '';
    const caseType = state.case.caseType?.valueObject?.code?.value as string;
    return caseType+'-'+caseNo;
}

function getGender(state: CaseState): string {
    const cender = state.case.patient.gender ? state.case.patient.gender : '';
    return cender === 'Male' ? 'Erkek' : 'Kadın';
}

function getDiagnoses(state: CaseState): string {
    return state.case.caseInformations?.diagnoses && state.case.caseInformations.diagnoses.length > 0 ? state.case.caseInformations.diagnoses[0]?.icdCodeName?.toString() : '';
}

function getVitalSigns(state: CaseState): string {
    const signs: IVitalSign[] = state.case.caseInformations?.vitalSigns as IVitalSign[];

    //  Tansiyon
    const taSign = signs.find( s => s.parameter.label === 'Tansiyon');
    let ta = '';
    if(taSign) {
        ta = `TA : ${taSign.input1} ${taSign.unit}`;
    }

    //  SpO2
    const psSign = signs.find( s => s.parameter.label === 'SpO2');
    let sp = '';
    if(psSign) {
        sp = `SpO2 : ${psSign.input1} ${psSign.unit}`;
    }

    //  Nabız
    const nabign = signs.find( s => s.parameter.label === 'Nabız');
    let nab = '';
    if(nabign) {
        nab = `Nabız : ${nabign.input1} ${nabign.unit}`;
    }

    //  Ateş
    const atesSign = signs.find( s => s.parameter.label === 'Ateş');
    let ates = '';
    if(atesSign) {
        ates = `Ateş : ${atesSign.input1} ${atesSign.unit}`;
    }

    //  Kan Şekeri
    const kstSign = signs.find( s => s.parameter.label === 'Kan Şekeri Tokluk');
    const ksaSign = signs.find( s => s.parameter.label === 'Kan Şekeri Açlık');
    let ka = '';
    if(kstSign || ksaSign) {
        ka = `Kan Şekeri Tokluk : ${kstSign?.input1} ${kstSign?.unit} / Açlık : ${ksaSign?.input1} ${ksaSign?.unit}`;
    }

    return ta+' | '+sp+' | '+nab+' | '+ates+' | '+ka;
}

function getServices(state: CaseState): string {
    const services = state.case.serviceInformations?.services?.map( s => s.serviceName);
    let result = '';
    if(services) {
        for(const service of services){
            result += service + ' / ';
        }
        result = result.substring(0, result.length-3);
    }
    return result;
}